const loadDependencies = ({ DEPENDENCIES, params }) => {
  const { alias, file, port } = params || {}
  return DEPENDENCIES.map((app) => {
    if (app.name === alias) return { name: alias, url: `http://localhost:${port}/${file}.js` }
    return app
  })
}

export default loadDependencies
